import { isIOS } from "./utils/platform";

export default function SafeAreaTop({ color }) {
  const finalColor = color || (isIOS ? "#EFF6FF" : "white");
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] pointer-events-none"
      style={{
        height: "var(--safe-top)",   // no extra pixels
        background: finalColor,
      }}
    />
  );
}
